import React from "react";
import { Box, Typography,  Link, List, ListItem, ListItemIcon } from "@mui/material";
import ShareIcon from "@mui/icons-material/Share";
import LockIcon from "@mui/icons-material/Lock";
import DeleteIcon from "@mui/icons-material/Delete";

import CloudIcon from "@mui/icons-material/Cloud";
import './appsection.css'


function AppSection() {

  const [tabValue, setTabValue] = React.useState("phone");

  const handleTabChange = (event: any, newValue: any) => {
    setTabValue(newValue);
  };

  return (
    <Box sx={{ maxWidth: 600, margin: "auto", p: 2, marginTop: '20px', }}  >
      {/* Privacy Information Section */}
      <Box
        sx={{
          border: "1px solid #ddd",
          borderRadius: 2,
          bgcolor: "#fff",
          marginBottom: '20px'
        }}
      >
        <List>
          <ListItem>
            <ListItemIcon sx={{ minWidth: '45px' }} >
              <ShareIcon sx={{ marginLeft: 0 }} />
            </ListItemIcon>
            <div className="text-2">
              <span>Tidak ada data yang dibagikan kepada pihak ketiga</span>
              <p>
                <Link className="text-2" href="#" underline="hover" sx={{ color: "text.secondary", textDecoration: "underline" }}>
                  Pelajari lebih lanjut
                </Link>
                <span> cara developer menyatakan pembagian data</span>
              </p>
            </div>
          </ListItem>
          <ListItem  >
            <ListItemIcon sx={{ minWidth: '45px' }}>
              <CloudIcon />
            </ListItemIcon>
            <div className="text-2">
              <span>Aplikasi ini dapat mengumpulkan jenis data berikut</span>
              <p>Lokasi, Info pribadi, dan 4 lainnya</p>
            </div>
          </ListItem>
          <ListItem  >
            <ListItemIcon sx={{ minWidth: '45px' }}>
              <LockIcon />
            </ListItemIcon>
            <div
              className="text-2"
            >
              <span>Data dienkripsi saat dalam pengiriman</span>
            </div>
          </ListItem>
          <ListItem>
            <ListItemIcon sx={{ minWidth: '45px' }} >
              <DeleteIcon />
            </ListItemIcon>
            <div className="text-2"><span>Anda dapat meminta agar data dihapus</span> </div>
          </ListItem>
        </List>
        <div className="mb-5">
          <Link m={3} className="text-2 " href="#" underline="hover" sx={{ fontWeight: "bold", color: "#01875f" }}>
            <span className="text-[#01875f] font-medium" > Lihat detail</span>
          </Link>
        </div>
      </Box>

      {/* Ratings and Reviews Section */}
      <Box>
        <Typography variant="h6" gutterBottom color="rgb(32, 33, 36)">
         <span className="VMq4uf"> Rating dan ulasan</span>
        </Typography>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          Rating dan ulasan telah diverifikasi
        </Typography>
        
      </Box>
    </Box>
  );
}

export default AppSection;
